export default __webpack_public_path__ + "static/media/stationary-storage.ac81aa70.png";